import React from 'react';
import { Icon } from '@iconify/react';
import './StatusRoadmap.css';
import { formatDateAccordingTo } from '..';

const statusList = [
  { id: 1, label: 'assigned', icon: 'material-symbols:assignment' },
  { id: 2, label: 'accepted', icon: 'material-symbols:thumb-up' },
  { id: 3, label: 'In Transit', icon: 'material-symbols:directions-car' },
  { id: 4, label: 'Arrived', icon: 'material-symbols:location-on' },
  { id: 5, label: 'In Progress', icon: 'material-symbols:build' },
  { id: 6, label: 'Completed', icon: 'material-symbols:check-circle' },
];

const StatusRoadmap = ({ statusData }) => {
  const statusMap = statusList.reduce((acc, status) => ({
    ...acc,
    [status.label]: status
  }), {});

  return (
    <div className="roadmap-container">
      <div className="roadmap">
        {statusList.map((status, index) => {
          const statusEntry = statusData.find(data => data.status === status.label);
          const isActive = !!statusEntry;
          return (
            <div key={status.id} className={`roadmap-item ${isActive ? 'active' : ''}`}>
              <div className="roadmap-icon">
                <Icon icon={status.icon} width="24" height="24" />
              </div>
              <div className="roadmap-content">
                <span className="status-label text-uppercase">{status.label}</span>
                {isActive && <span className="status-time">{formatDateAccordingTo(statusEntry.date_time) || ''}</span>}
              </div>
              {index < statusList.length - 1 && (
                <div className={`roadmap-line ${isActive ? 'active' : ''}`}></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatusRoadmap;